import http from "./http.js";
import moment from "moment";

async function getPayment(id) {
  try {
    const response = await http.get(`payments/${id}`);
    return {
      date: response.data.date,
      amount: response.data.amount,
      isPaymentForPackage: response.data.isPaymentForPackage,
      hours: response.data.hours,
      client: response.data.client ?
        {
          id: response.data.client.id,
          title: response.data.client.title,
        } :
        null,
      project: response.data.project ?
        {
          id: response.data.project.id,
          title: response.data.project.title,
        } :
        null,
      invoice: response.data.invoice ?
        {
          id: response.data.invoice.id,
          title: response.data.invoice.title,
        } :
        null,
      paymentType: response.data.paymentType ?
        {
          id: response.data.paymentType.id,
        } :
        null,
      paymentSource: response.data.paymentSource ?
        {
          id: response.data.paymentSource.id,
          title: response.data.paymentSource.title,
        } :
        null,
      paymentPurpose: response.data.paymentPurpose ? response.data.paymentPurpose : null,
      balanceCorrection: response.data.balanceCorrection,
      payer: response.data.payer ? {
        id: response.data.payer.id,
        title: response.data.payer.title,
      } : null,
    };
  } catch (err) {
    throw err;
  }
}

async function updatePayment(id, payment, notify = false) {
  try {
    const response = await http.put(`payments/${id}?notifyClientManager=${notify}`, payment);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createPayment(payment, notify = false) {
  try {
    const response = await http.post(`payments?notifyClientManager=${notify}`, payment);
    return response;
  } catch (err) {
    throw err;
  }
}
async function createPaymentPrivat24(transaction) {
  const { data: paymentId } = await http.post("payments/privat24", transaction);
  return paymentId;
}

async function totalPaymentAmount(filter = {}, search = "") {
  const {
    dateFrom,
    dateTo,
  } = filter;
  try {
    const response = await http.get("payments/totals/amount", {
      params: {
        dateFrom,
        dateTo,
        searchTerm: search,
        paymentType: filter.paymentType ? filter.paymentType.id : null,
        paymentSourceId: filter.paymentSource ? filter.paymentSource.id : null,
        managerId: filter.manager ? filter.manager.id : null,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getPayments(page = 1, rowsPerPage = 9, search = "", filter = null) {
  try {
    const queryFilter = `&filter.dateFrom=${filter.dateFrom}&filter.dateTo=${
      filter.dateTo
    }&filter.paymentType=${
      filter.paymentType ? filter.paymentType.id : null
    }&filter.paymentSourceId=${
      filter.paymentSource ? filter.paymentSource.id : null
    }&filter.managerId=${filter.manager ? filter.manager.id : null}`;
    const response = await http
      .get(
        `payments?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${queryFilter}`
      );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getPaymentInvoices(id) {
  try {
    const response = await http.get(`payments/invoice/${id}`);
    return response.data.map(i => {
      return {
        id: i.id,
        date: i.date,
        amount: i.amount,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function getNotifications(paymentId) {
  const res = await http.get(`payments/${paymentId}/notifications`);
  return res.data.map(n => {
    return {
      email: n.email,
      isDilevered: n.isDilevered,
      deliveredAt: moment(n.deliveredAt).format("DD.MM.YY"),
    };
  });
}

export {
  getPayment,
  updatePayment,
  createPayment,
  createPaymentPrivat24,
  totalPaymentAmount,
  getPayments,
  getPaymentInvoices,
  getNotifications,
};